const context = require.context('.', false, /Mixin\.js$/);

export const mixins = context.keys().reduce((pre, cur) => {
  const module = context(cur);
  const name = cur.replace(/^\.\/(.*)\.js$/, '$1');
  return Object.assign(pre, { [name]: module.default });
}, {});

/**
 * 组合多个混入类
 * @param {Class[]} mixins 混入类数组
 * @returns {Class} 组合后的混入函数
 */
export const composeMixins = (mixins) => (Base) => mixins.reduce((acc, mixin) => mixin(acc), Base);
